import { IKeyValue } from 'shared/utils';



export interface IListagemUsuario {
  IdUsuario: number,
  UsuarioNome: string,
  nrCpf: string,
  UsuarioStatus: string,
  usu_Senha: string,
  LoginAD: string,
  Login: string,
  DataLoginUltimo: string,
  EMail: string,
  CodigoIdentificacaoFuncionario: string,
  FlagLogin: string,
  IdUsuarioInclusao: number,
  usu_MarcpermId:number,
  FlagSolicNovaSenha:string,
  ROW_NUM?: number

}

export interface IResponseUsuario {
  rows: IListagemUsuario[];
  count: number;
}

export interface ICreateUsuario {
  UsuarioNome?: string,
  nrCpf?: string,
  UsuarioStatus?: string,
  LoginAD?: string,
  Login?: string,
  EMail?: string,
  CodigoIdentificacaoFuncionario?: string,
  usu_Flg_Nova_Senha?: string,
  usu_DT_Ult_Login?: Date,
  usu_Senha?: string,
  usu_Dt_Senha?: Date,
  usu_MarcpermId?: number

}

export const InicitalCreateUsuario = {
  UsuarioNome: '',
  nrCpf: '',
  UsuarioStatus: '',
  LoginAD: '',
  Login: '',
  EMail: '',
  CodigoIdentificacaoFuncionario: '',
  usu_Flg_Nova_Senha: 'S',
  usu_DT_Ult_Login: new Date(),
  usu_Senha: '',
  usu_Dt_Senha: new Date(),
  usu_MarcpermId: 121

};


export const listKeyValueUsuarioStatus: IKeyValue[] = [
  {
    key: 'A',
    value: 'Ativo'
  }, {
    key: 'I',
    value: 'Inativo'
  }, {
    key: 'E',
    value: 'Excluído'
  }];

export interface IListagemUsuarioRole {
  IdUsuario: number,
  IdRole: number,
  IdUsuarioInclusao: number,
  DataInclusaoRole: string,
  CodigoRole: string,
  NomeRole: string,
  ROW_NUM?: number
}

export interface ICreateUsuarioRole {
  IdRole?: number,
}

export interface IResponseUsuarioRole {
  rows: IListagemUsuarioRole[];
  count: number;
}

export const InicitalCreateUsuarioRole = {
  IdRole: 0,
};

export interface IListagemUsuarioOrg {
  UsuarioId: number,
  OrgCod: number,
  UsuarioAcaoId: number,
  DhIns: string,
  ORG_NM: string,
  UsuarioNome: string,
  UsuarioAcaoNome: string,
  ROW_NUM: number
}

export interface ICreateUsuarioOrg {
  
  CodigoOrganizacao?: number,
  dh_acao?: Date
}

export interface IResponseUsuarioOrg {
  rows: IListagemUsuarioOrg[];
  count: number;
}

export const InicitalCreateUsuarioOrg = {
  
  CodigoOrganizacao: 0,
  dh_acao: new Date(),
};

export interface IResponseLogUsuario {
  count: number;
  rows: IListagemLogsUsu[];
}

export interface IListagemLogsUsu {
  UsuarioId: number;
  UsuarioAcaoId: number;
  UsuarioStatus: string;
  UsuarioAcaoNome: string;
  UsuarioNome: string;
  DhLog: Date;
  ROW_NUM: number;
}

export interface IResponseLogUsuarioPag {
  count: number;
  rows: IListagemLogsUsuPag[];
}

export interface IListagemLogsUsuPag {
  UsuarioId: number,
  DhLog: Date,
  USU_ST: string,
  UsuarioStatus: string,
  UsuarioAcaoId: number,
  USU_NM_INS: string
}

export interface IResponseLogUsuarioRole {
  count: number;
  rows: IListagemLogsUsuRole[];
}

export interface IListagemLogsUsuRole {
  Acao: string;
  DhIns: Date;
  DhLog: Date;
  LogId: number;
  ROW_NUM: number;
  RoleId: number;
  USU_NM: string;
  USU_NM_INS: string;
  UsuarioAcaoId: number;  
  UsuarioId: number;

}

export interface IListagemLogUsuarioOrg {
  UsuarioId: number,
  OrgCod: number,
  UsuarioAcaoId: number,
  OrgNome:string,
  USUORGLOG_DH_ACESSO: Date,
  ACAO: string,
  UsuarioNome: string,
  UsuarioAcaoNome: string,
  ROW_NUM: number
}

export interface IResponseLogUsuarioOrg {
  rows: IListagemLogUsuarioOrg[];
  count: number;
}